import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/pgcc/';

class PgccService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findAllByFiltro(idContribuinte, filtro) {
        return axios.get(API_URL + 'all?idContribuinte='+idContribuinte+'&filtro='+filtro, {headers: this.headers});
    }

    findAllPaiByFiltro(idContribuinte, filtro) {
        return axios.get(API_URL + 'allPai?idContribuinte='+idContribuinte+'&filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data));
    }

    findAllTipos() {
        return axios.get(API_URL + 'allTipos', {headers: this.headers});
    }
    
    save(pgcc) {
        return axios.post(API_URL, JSON.stringify(pgcc),
        {headers: this.headers});
    }

    get(pgccId) {
        return axios.get(API_URL+pgccId, {headers: this.headers});
    }

    remove(pgccId) {
        return axios.delete(API_URL+pgccId, {headers: this.headers});
    }

    ativar(pgccId) {
        return axios.post(API_URL+ 'ativar/'+pgccId, null, {headers: this.headers});
    }

    upload(idCliente, idContribuinte, file) {
        const formData = new FormData();
        formData.append('file', file, file.name);
        return axios.post(API_URL+'uploadPgcc?idCliente='+idCliente+'&idContribuinte='+idContribuinte, formData, { headers: this.headers });
    }

}

export default new PgccService();